import getApiClient from 'src/utils/getApiClient'
import type {
  ApiAnalysesLpuListCountParams,
  ApiAnalysesLpuListCountResponse,
} from 'src/components/pages/[town-translit]/diagnostika/analiz/api/apiAnalysesLpuListCount.types'

const LPU_LIST_COUNT_URL = '/ajax/diagnostika/analyses/lpu-list-count/'

const apiClient = getApiClient()

const apiAnalysesLpuListCount = {
  async get(params: ApiAnalysesLpuListCountParams): Promise<ApiAnalysesLpuListCountResponse> {
    const { data } = await apiClient.get<ApiAnalysesLpuListCountResponse>(LPU_LIST_COUNT_URL, {
      params,
    })

    return data
  },
}

export default apiAnalysesLpuListCount
